import { ROUTES } from '~/utils/routes';

export const BREADCRUMB_ITEMS = [
  { label: 'ストレスチェック', href: ROUTES.STRESS_ASSESSMENTS.INDEX },
  { label: 'ストレスチェックの実施' },
];
